/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Common_Logout_FailedInputs */

const en_auth_common_logout_failed = /** @type {(inputs: Auth_Common_Logout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out failed`)
};

const es_auth_common_logout_failed = /** @type {(inputs: Auth_Common_Logout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cerrar sesion`)
};

/**
* | output |
* | --- |
* | "Log out failed" |
*
* @param {Auth_Common_Logout_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_common_logout_failed = /** @type {((inputs?: Auth_Common_Logout_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Common_Logout_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_common_logout_failed(inputs)
	return es_auth_common_logout_failed(inputs)
});